import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { Button, ClickAwayListener } from '@mui/material';

import { useSite } from '@labradorsports/utils';

import { NavLinkWithQuery } from '../../shared/structural/index.js';
import { Selectors, useLogoutMutation } from '../../store/index.js';
import NotificationBadge from '../notification-badge/notification-badge.js';

interface Props {
    open: boolean;
    onClose: AnyFunction;
    onNotificationsClick?: () => void;
}

const LoggedInMenu: FC<Props> = ({ onClose, open, onNotificationsClick }) => {
    const nodeRef = useRef<HTMLDivElement>(null);
    const { Config } = useSite();
    const [logout] = useLogoutMutation();
    const currentTeam = useSelector(Selectors.currentTeam);
    const navLinks = [['Profile', '/profile/account/basic']];

    if (Config.Features.TeamDocuments && currentTeam) {
        navLinks.push(['Team Documents', '/documents/list']);
    }

    const navLink = ([text, to]: [string, string]) => (
        <NavLinkWithQuery className="menu-item" key={to} to={to} onClick={onClose}>
            {text}
        </NavLinkWithQuery>
    );

    const handleNotificationsClick = () => {
        onClose();
        onNotificationsClick?.();
    };

    const NotificationLink = () => (
        <button className="menu-item" onClick={handleNotificationsClick}>
            <span className="notification-link">
                Notifications
                <NotificationBadge />
            </span>
        </button>
    );

    return (
        <CSSTransition nodeRef={nodeRef} classNames="header-menu" timeout={200} mountOnEnter unmountOnExit in={open}>
            <ClickAwayListener onClickAway={onClose}>
                <div ref={nodeRef} className="logged-in-menu">
                    {navLinks.map(navLink)}
                    {Config.Features.Community ? navLink(['Community', '/community']) : null}
                    <NotificationLink />
                    <a
                        className="menu-item"
                        href="https://labradorsports.com/labrador-sports-blog/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Blog
                    </a>
                    <Button className="bs logout-button" onClick={() => logout()}>
                        Log Out
                    </Button>
                </div>
            </ClickAwayListener>
        </CSSTransition>
    );
};

export default LoggedInMenu;
